import { Box, Skeleton } from '@mui/material';

type Props = {
	size?: number;
	width?: number;
	height?: number;
};

const IconSkeleton = ({ size = 24, width, height }: Props) => (
	<Box
		component="span"
		sx={{
			display: 'inline-flex',
			alignItems: 'center',
			justifyContent: 'center',
			width: width ? `${width}px` : `${size}px`,
			height: height ? `${height}px` : `${size}px`,
			lineHeight: 0,
			flexShrink: 0,
			verticalAlign: 'middle',
		}}
	>
		<Skeleton
			variant="rectangular"
			animation="wave"
			width="100%"
			height="100%"
			sx={{
				transform: 'none',
				borderRadius: 1,
			}}
		/>
	</Box>
);

export default IconSkeleton;
